import { useLocation } from 'react-router-dom';
import { Draft } from '../DraftPage';
import { DraftProvider } from '../context/DraftProvider';

const DraftWrapper = () => {
  // console.log('[DRAFT WRAPPER] Se reenderizo');

  const location = useLocation();
  const filename = location.state?.filename || "";

  return (
    <DraftProvider>
      <Draft originalFilename = {filename}/>
    </DraftProvider>
  );
};

export default DraftWrapper;